import { api } from '@/contexts/AuthContext';

type FetchOptions = { force?: boolean };

function dedupeInflight<T>(
  slot: { current: Promise<T> | null },
  force: boolean | undefined,
  factory: () => Promise<T>
): Promise<T> {
  if (!force && slot.current) return slot.current;
  const promise = factory().finally(() => {
    if (slot.current === promise) slot.current = null;
  });
  slot.current = promise;
  return promise;
}

const campaignListsInflight: {
  current: Promise<PromiseSettledResult<{ data: any }>[]> | null;
} = { current: null };

/**
 * Parallel fetch of all campaign list endpoints, shared across StrictMode remounts.
 */
export function fetchAllCampaignLists(options?: FetchOptions) {
  return dedupeInflight(campaignListsInflight, options?.force, () =>
    Promise.allSettled([
      api.get('/renewals'),
      api.get('/campaigns'),
      api.get('/dynamics'),
      api.get('/calendar-campaigns'),
    ])
  );
}
